import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'BankingSettings';
const ENDPOINT = `/banking-settings/`;

@Injectable({
    providedIn: 'root'
})
export class BankingSettingsService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
